/* eslint-disable react/react-in-jsx-scope */

import { HowYourPlanWorksProps } from './types';
import { Container, ContainerTitle } from './styles';
import { CardsCarousel } from '../CardsCarousel/cards-carousel';
import { PlanCard } from './plan-card';

export const HowYourPlanWorks = (props: HowYourPlanWorksProps) => {
  const { title, cards, onActionClick } = props;
  const cardsMap = cards.map((card) => ({
    key: card.title,
    content: <PlanCard cardData={card} onActionClick={onActionClick} />,
  }));
  return (
    <Container>
      <ContainerTitle>{title}</ContainerTitle>
      <CardsCarousel cardsData={cardsMap} />
    </Container>
  );
};
